import React from 'react';
//import { PostData } from '../service/postData';
import '../App.css';
import { Route, Switch } from 'react-router';
import routes from '../routes/routes';
//import { ToastContainer } from "react-toastify";
//import "react-toastify/dist/ReactToastify.css";

//----Include Fragment Pages-----
import HeaderSection from '../fragment_folder/header';
import MenuSection from '../fragment_folder/menusBusiness';
import TopHeaderPage from '../fragment_folder/topBusinessHeader';
import FooterPage from '../fragment_folder/footer';
//----End Include Fragment Pages-----

// ----- All Business / Company Pages Here...
import _business_DashboardPanel from '../views_folder/businessController/dashboard';
import _business_profilePanel from '../views_folder/businessController/profile/profile';
import _business_BusinessUserListPanel from '../views_folder/businessController/businessUser/manageBusinessUser';
import _business_CompanyListPanel from '../views_folder/businessController/company/companyList';
import _business_CompanyAddPanel from '../views_folder/businessController/company/companyAdd';
import _business_CommonSettingPanel from '../views_folder/businessController/commonSetting/commonSetting';
import _my_subscription from "../views_folder/subscription/MySubscription";

// ----- All Items / Services / Party Pages Here...
import _user_AddParty from '../views_folder/userController/businessParty/manageAddParty';
import _user_Party from '../views_folder/userController/businessParty/party';
import _user_createItem from '../views_folder/userController/userItem/manageAddItem';
import _user_itemLists from '../views_folder/userController/userItem/itemList';
import _user_serviceList from '../views_folder/userController/userItem/manageAllService';
import _user_createService from '../views_folder/userController/userItem/manageAddService';
import _user_unitList from '../views_folder/userController/unit/unit';

// ----- All Sale Transaction Pages Here...
import _user_createSale from '../views_folder/userController/userSale/ManageSaleCreate';
import _user_createSaleReturn from '../views_folder/userController/userSale/ManageSaleReturnCreate';
import _user_createSaleDelvChallan from '../views_folder/userController/userSale/ManageDeliveryChallanCreate';
import _user_createSaleEstimate from '../views_folder/userController/userSale/ManageSaleEstimateCreate';
import _user_createSaleOrder from '../views_folder/userController/userSale/ManageSaleOrderCreate';

import _user_saleInvoice from '../views_folder/userController/userSale/manageSaleList';
import _user_saleReturnList from '../views_folder/userController/userSale/manageSaleReturnList';
import _user_saleDelvChallanList from '../views_folder/userController/userSale/manageDeliveryChallanList';
import _user_saleEstimateList from '../views_folder/userController/userSale/manageSaleEstimateList';
import _user_saleOrderList from '../views_folder/userController/userSale/manageSaleOrderList';

import _user_createSalePaymentIn from '../views_folder/userController/userSale/manageCreatePaymentIn';
import _user_salePaymentInList from '../views_folder/userController/userSale/manageSalePaymentInList';

import _user_createSaleReceivePaymentIn from '../views_folder/userController/userSale/manageCreateReceivePaymentIn';
import _user_createSaleMakePaymentOut from '../views_folder/userController/userSale/manageCreateMakePaymentOut';

// ----- All Purchase Transaction Pages Here...
import _user_createPurchase from '../views_folder/userController/userPurchase/ManagePurchaseCreate';
import _user_createPurchaseReturnDebitNote from '../views_folder/userController/userPurchase/ManagePurchaseReturnCreate';
import _user_createPurchaseOrder from '../views_folder/userController/userPurchase/ManagePurchaseOrderCreate';

import _user_purchaseInvoice from '../views_folder/userController/userPurchase/managePurchaseList';
import _user_createPurchasePaymentout from '../views_folder/userController/userPurchase/manageCreatePaymentOut';
import _user_purchasePaymentOutList from '../views_folder/userController/userPurchase/managePurchasePaymentOutList';

import _user_purchaseReturnList from '../views_folder/userController/userPurchase/managePurchaseReturnList';
import _user_purchaseOrderList from '../views_folder/userController/userPurchase/managePurchaseOrderList';

import _user_purchaseMakePayment from '../views_folder/userController/userPurchase/manageCreatePurchaseToPaymentOut';
//import _user_purchaseToReturn from '../views_folder/userController/userPurchase/manageCreatePurchaseToReturn';
import _user_purchaseMakePaymentIn from '../views_folder/userController/userPurchase/manageCreatePurchaseToPaymentIn';

import _user_expense from '../views_folder/userController/userExpense/expenseList';
import _user_addExpense from '../views_folder/userController/userExpense/ManageExpenseCreate';
import _user_addExpenseDuplicate from '../views_folder/userController/userExpense/manageCreateExpenseToDuplicate';
import _user_addExpensePayment from '../views_folder/userController/userExpense/manageCreateExpensePayment';

import _user_accountList from '../views_folder/userController/cashBank/manageBankList';
import _user_chequeList from '../views_folder/userController/chequeBank/chequeList';
import _user_cashInHandList from '../views_folder/userController/cashBank/manageCashINHand';
import _user_loacAccountList from '../views_folder/userController/cashBank/manageLoanAccountList';
import _user_loacAccountStatementList from '../views_folder/userController/cashBank/manageViewLoanStatementList';

// -----Invoices PDF
import salePdfDialog from '../views_folder/userController/Invoices/Sale/SalePdfDialog';
import saleReturnPdfDialog from '../views_folder/userController/Invoices/SaleReturn/SaleReturnPdfDialog';
import purchasePdfDialog from '../views_folder/userController/Invoices/Purchase/PurchasePdfDialog';
import purchaseReturnPdfDialog from '../views_folder/userController/Invoices/PurchaseReturn/PurchaseReturnPdfDialog';
import challanPdfDialog from '../views_folder/userController/Invoices/Challan/ChallanPdfDialog';
import saleOrderPdfDialog from '../views_folder/userController/Invoices/SaleOrder/SaleOrderPdfDialog';
import saleEstimatePdfDialog from '../views_folder/userController/Invoices/SaleEstimate/SaleEstimatePdfDialog';
import purchaseOrderPdfDialog from '../views_folder/userController/Invoices/PurchaseOrder/PurchaseOrderPdfDialog';
import otherIncomePdfDialog from '../views_folder/userController/Invoices/OtherIncome/OtherIncomePdfDialog';
import expensePdfDialog from '../views_folder/userController/Invoices/Expense/ExpensePdfDialog';
import paymentInPdfDialog from '../views_folder/userController/Invoices/PaymentIn/PaymentInPdfDialog';
import paymentOutPdfDialog from '../views_folder/userController/Invoices/PaymentOut/PaymentOutPdfDialog';
import loanStatementPdfDialog from '../views_folder/userController/Invoices/LoanStatement/LoanStatementPdfDialog';

import _user_smsListData from '../views_folder/userController/smsSetting/smsSettingList';
import _user_partyToPartyTransfer from '../views_folder/userController/businessParty/partyToPartyTransfer';

// -- All Reports Page
import _user_reports from '../views_folder/userController/reports/reports';
import _user_allPrefixList from '../views_folder/businessController/commonSetting/childFolder/allPrefixListData';

import _user_otherIncomeTransList from '../views_folder/userController/otherIncome/otherIncomeList';
import _user_otherIncomeCreateTrans from '../views_folder/userController/otherIncome/quickAddOtherIncome';
import _user_otherDuplicateIncomeCreate from '../views_folder/userController/otherIncome/quickAddDuplicateOtherIncome';
import _user_otherIncomeList from '../views_folder/userController/otherIncome/manageOtherIncomeList';
import _user_utilitiyImportItemList from '../views_folder/userController/businessUtilities/manageImportItemList';
import _user_utilitiyImportPartyList from '../views_folder/userController/businessUtilities/managePartyList';
import _user_utilitiyExportItemList from '../views_folder/userController/businessUtilities/manageExportItemList';
import _user_utilitiyBulkUpdateItemList from '../views_folder/userController/businessUtilities/manageBulkUpdateItem';
import _user_utilitiyBulkUpdateServiceList from '../views_folder/userController/businessUtilities/manageBulkUpdateServices';

import paymentSubscription from "../views_folder/subscription/PaymentSubscription";
import ChoosePlan from "../views_folder/subscription/ChoosePlan";
import useAutoLogout from './useAutoLogout';

export default function CustomerPanel() {
    useAutoLogout();
  return (
    <div id="page-wrapper">
      <div id="page-container" className="sidebar-o enable-page-overlay side-scroll page-header-modern main-content-boxed">
        <aside id="side-overlay">
          <HeaderSection pagekey="business" />
        </aside>
        <MenuSection pageId={global.BACK_URL} />
        <TopHeaderPage />
        <main id="main-container">
          <div>
            <Switch>
              {/* Business Routes */}
              <Route exact path={routes._business_DashboardPanel} component={_business_DashboardPanel} />
              <Route exact path={routes._business_profilePanel} component={_business_profilePanel} />
              <Route exact path={routes._business_BusinessUserListPanel} component={_business_BusinessUserListPanel} />
              <Route exact path={routes._business_CompanyListPanel} component={_business_CompanyListPanel} />
              <Route exact path={routes._business_CompanyAddPanel} component={_business_CompanyAddPanel} />
              <Route exact path={routes._business_BusinessCommonSettingPanel} component={_business_CommonSettingPanel} />
              <Route exact path={routes._business_my_subscription} component={_my_subscription} />

              {/* Party / Items / Services */}
              <Route exact path={routes._user_PartyPanel} component={_user_Party} />
              <Route exact path={routes._user_AddParty} component={_user_AddParty} />
              <Route exact path={routes._user_saleInvoice} component={_user_saleInvoice} />
              <Route exact path={routes._user_saleInvoice_Add} component={_user_createSale} />
              <Route exact path={routes._user_Item_Add} component={_user_createItem} />
              <Route exact path={routes._user_itemList} component={_user_itemLists} />
              <Route exact path={routes._user_ServiceList} component={_user_serviceList} />
              <Route exact path={routes._user_Service_Add} component={_user_createService} />
              <Route exact path={routes._user_unitList} component={_user_unitList} />

              {/* Sale Transactions */}
              <Route exact path={routes._user_saleEstimateList} component={_user_saleEstimateList} />
              <Route exact path={routes._user_saleEdtimate_Add} component={_user_createSaleEstimate} />
              <Route exact path={routes._user_saleOrderList} component={_user_saleOrderList} />
              <Route exact path={routes._user_saleOrder_Add} component={_user_createSaleOrder} />
              <Route exact path={routes._user_saleOrderDuplicate_Add} component={_user_createSaleOrder} />
              <Route exact path={routes._user_saleDelvChallanList} component={_user_saleDelvChallanList} />
              <Route exact path={routes._user_saleDelvChallan_Add} component={_user_createSaleDelvChallan} />
              <Route exact path={routes._user_salePaymentInList} component={_user_salePaymentInList} />
              <Route exact path={routes._user_salePaymentIn_Add} component={_user_createSalePaymentIn} />
              <Route exact path={routes._user_saleReturnList} component={_user_saleReturnList} />
              <Route exact path={routes._user_saleRetCreditNote_Add} component={_user_createSaleReturn} />
              <Route exact path={routes._user_saleReceivePaymentIn_Add} component={_user_createSaleReceivePaymentIn} />
              <Route exact path={routes._user_saleMakePaymentOut_Add} component={_user_createSaleMakePaymentOut} />

              {/* Purchase Transactions */}
              <Route exact path={routes._user_purchaseInvoice} component={_user_purchaseInvoice} />
              <Route exact path={routes._user_purchaseInvoice_Add} component={_user_createPurchase} />
              <Route exact path={routes._user_purchasePaymentOut_Add} component={_user_createPurchasePaymentout} />
              <Route exact path={routes._user_purchasePaymentOutList} component={_user_purchasePaymentOutList} />
              <Route exact path={routes._user_purchaseReturnList} component={_user_purchaseReturnList} />
              <Route exact path={routes._user_purchaseRetDebitNote_Add} component={_user_createPurchaseReturnDebitNote} />
              <Route exact path={routes._user_purchaseOrder_Add} component={_user_createPurchaseOrder} />
              <Route exact path={routes._user_purchaseOrderList} component={_user_purchaseOrderList} />
              <Route exact path={routes._user_purchaseMakePayment} component={_user_purchaseMakePayment} />
              <Route exact path={routes._user_purchaseMakePaymentIn} component={_user_purchaseMakePaymentIn} />

              {/* Expenses */}
              <Route exact path={routes._user_expense} component={_user_expense} />
              <Route exact path={routes._user_addExpense} component={_user_addExpense} />
              <Route exact path={routes._user_addExpenseDuplicate} component={_user_addExpenseDuplicate} />
              <Route exact path={routes._user_addExpensePayment} component={_user_addExpensePayment} />

              {/* Accounts */}
              <Route exact path={routes._user_accountList} component={_user_accountList} />
              <Route exact path={routes._user_chequeList} component={_user_chequeList} />
              <Route exact path={routes._user_cashInHandList} component={_user_cashInHandList} />
              <Route exact path={routes._user_loacAccountList} component={_user_loacAccountList} />
              <Route exact path={routes._user_loacAccountStatementList} component={_user_loacAccountStatementList} />

              {/* PDF Dialogs */}
              <Route exact path="/business/salePdfDialog/" component={salePdfDialog} />
              <Route exact path="/business/saleReturnPdfDialog/" component={saleReturnPdfDialog} />
              <Route exact path="/business/purchasePdfDialog/" component={purchasePdfDialog} />
              <Route exact path="/business/purchaseReturnPdfDialog/" component={purchaseReturnPdfDialog} />
              <Route exact path="/business/challanPdfDialog/" component={challanPdfDialog} />
              <Route exact path="/business/saleOrderPdfDialog/" component={saleOrderPdfDialog} />
              <Route exact path="/business/saleEstimatePdfDialog/" component={saleEstimatePdfDialog} />
              <Route exact path="/business/purchaseOrderPdfDialog/" component={purchaseOrderPdfDialog} />
              <Route exact path="/business/otherIncomePdfDialog/" component={otherIncomePdfDialog} />
              <Route exact path="/business/expensePdfDialog/" component={expensePdfDialog} />
              <Route exact path="/business/paymentInPdfDialog/" component={paymentInPdfDialog} />
              <Route exact path="/business/paymentOutPdfDialog/" component={paymentOutPdfDialog} />
              <Route exact path="/business/loanStatementPdfDialog/" component={loanStatementPdfDialog} />

              {/* SMS */}
              <Route exact path={routes._business_smsAddListData} component={_user_smsListData} />
              <Route exact path={routes._user_partyToPartyTransfer} component={_user_partyToPartyTransfer} />

              {/* Reports */}
              <Route exact path={routes._user_reports} component={_user_reports} />
              <Route exact path={routes._user_allPrefixList} component={_user_allPrefixList} />

              {/* Other Income */}
              <Route exact path={routes._user_otherIncomeTransList} component={_user_otherIncomeTransList} />
              <Route exact path={routes._user_otherIncomeCreateTrans} component={_user_otherIncomeCreateTrans} />
              <Route exact path={routes._user_otherIncomeList} component={_user_otherIncomeList} />
              <Route exact path={routes._user_otherDuplicateIncomeCreate} component={_user_otherDuplicateIncomeCreate} />

              {/* Utilities */}
              <Route exact path={routes._user_utilitiyImportItemList} component={_user_utilitiyImportItemList} />
              <Route exact path={routes._user_utilitiyImportPartyList} component={_user_utilitiyImportPartyList} />
              <Route exact path={routes._user_utilitiyExportItemList} component={_user_utilitiyExportItemList} />
              <Route exact path={routes._user_utilitiyBulkUpdateItemList} component={_user_utilitiyBulkUpdateItemList} />
              <Route exact path={routes._user_utilitiyBulkUpdateServiceList} component={_user_utilitiyBulkUpdateServiceList} />

              {/* Subscription */}
              <Route exact path={routes._paymentSubscription} component={paymentSubscription} />
              <Route exact path={routes._choosePlan} component={ChoosePlan} />
            </Switch>
          </div>
        </main>
        <FooterPage />
      </div>
    </div>
  );
}